<template>
  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="账号名称">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入账号名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品分类-->
    <!-- <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">新增渠道类目</el-button>
    </div> -->
    <el-table :data="tableData" border style="width: 100%">

      <el-table-column prop="card.name" label="姓名">
      </el-table-column>
      <el-table-column prop="nickname" label="昵称">
      </el-table-column>

      <el-table-column prop="card.address" label="开户行">
      </el-table-column>

      <el-table-column prop="card.number" label="银行卡号/支付宝账号">
      </el-table-column>
      <el-table-column prop="" label="提现方式">
        <template slot-scope="scope">
          <div v-if="scope.row.type==1">银行卡</div>
          <div v-else-if="scope.row.type==2">支付宝</div>
          <div v-else>暂不明确</div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="提现类型">
        <template slot-scope="scope">
          <div v-if="scope.row.status==1">提现</div>
          <div v-else-if="scope.row.status==2">结算</div>
          <div v-else>暂不明确</div>
        </template>
      </el-table-column>
      <el-table-column prop="situation" label="金额状态">
        <template slot-scope="scope">
          <div v-if="scope.row.situation==1">已到账</div>
          <div v-else-if="scope.row.situation==2">未到账</div>
          <div v-else-if="scope.row.situation==3">已拒绝</div>
        </template>
      </el-table-column>
      <el-table-column prop="money" label="提现金额">
      </el-table-column>
      <el-table-column prop="word" label="备注">
      </el-table-column>
      <el-table-column prop="card.identity_card" label="身份证号">
      </el-table-column>
      <el-table-column prop="card.mobile" label="电话">
      </el-table-column>
      <el-table-column prop="card.type" label="支付类型">
        <template slot-scope="scope">
          <div v-if="scope.row.card.type==1">银行卡</div>
          <div v-else-if="scope.row.card.type==2">支付宝</div>
          <div v-else>暂不明确</div>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="创建时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button @click="editClick(scope.row)" type="primary" size="small" :disabled="scope.row.situation == 1">审核</el-button>
          <el-button type="danger" size="small" @click="toedit(scope)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next" :total="totalDataNumber"></el-pagination>
    </div>
    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="categoryModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <Edit v-if="open_edit" :open_edit="open_edit" :form="userModel" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import ChannelApi from "@/api/channel.js";
import Add from "./Add.vue";
import Edit from "./edit.vue";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    Add,
    Edit
  },
  data() {
    return {
      /*当前编辑的对象*/
      categoryModel: {
        catList: [],
        model: {}
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 4,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        name: ""
      },
      tableData: [],
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    this.getData();
  },
  methods: {
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      ChannelApi.WithdrawalList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*选择第几页*/
    handleCurrentChange(val) {},
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      console.log(e, f);
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_edit = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    /*打开编辑*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_edit = true;
    },

    handleClick(row) {
      console.log(row);
    },
    /*打开添加*/
    addClick() {
      this.open_add = true;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/channel/category/cashrewords/index.vue